import mlFunctionsClient from '../interceptor.mlFunctionsClient';

const smartGeofenceEndpoints = {
  get: (config) =>
    mlFunctionsClient.get('/GetSmartGeofences', config),

  checkCompliance: (data, config) =>
    mlFunctionsClient.post('/CheckGeofenceCompliance', data, config),
};

export default smartGeofenceEndpoints;
